import { useDispatch } from 'react-redux';
import { TypesStatusListFilter } from '../../../../data/data-products'
import { AvailableChapels } from '../../../../types/chapel';
import { setSelectedChapelReport } from '../../../../features/reports/reportsSlice';
import useReport from '../../../../hooks/actions/useReport';

interface ChapelsCheckboxProps {
    chapel: AvailableChapels
}

export default function ChapelsCheckbox({ chapel }: ChapelsCheckboxProps) {
    
    const dispatch = useDispatch()
    const { chapelIds } = useReport()
    
    return (
        <label
            htmlFor={`chapel-${chapel.chapelID}`}
            className="flex items-center gap-2 cursor-pointer p-1.5 rounded border border-gray-300"
        >
            <input
                id={`chapel-${chapel.chapelID}`}
                type="checkbox"
                className="w-[14px] h-[14px] text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                checked={chapelIds.includes(chapel.chapelID)}
                onChange={() => dispatch(setSelectedChapelReport(chapel))}
            />
            <span className="text-gray-700 text-[13px]">{chapel.chapelName}</span>
        </label>
    )
}
